// Stage 96 — the app-shell sidebar width preference (per-user). Applied as a
// `data-sidebar-width` attribute on document.documentElement, mirroring the
// Stage 85a theme pattern (data-mode/data-pal): tokens.css keys
// --cos-rail-width-active on it, and cos-app-shell's grid reads that with a
// --cos-rail-width-md (260px) fallback. So `compact` — or an absent pref —
// keeps the pre-96 260px width: zero breakage for existing users.

export type SidebarWidth = 'compact' | 'comfortable' | 'wide';

export const SIDEBAR_WIDTHS: SidebarWidth[] = ['compact', 'comfortable', 'wide'];

export const SIDEBAR_WIDTH_LABEL: Record<SidebarWidth, string> = {
	compact: 'Compact',
	comfortable: 'Comfortable',
	wide: 'Wide',
};

export function isSidebarWidth(v: unknown): v is SidebarWidth {
	return v === 'compact' || v === 'comfortable' || v === 'wide';
}

/** Set data-sidebar-width on documentElement. `compact` removes the attribute
 *  (the token fallback gives 260px) so the DOM stays clean for the default. */
export function applySidebarWidth(width: SidebarWidth): void {
	if (typeof document === 'undefined') return;
	const root = document.documentElement;
	if (width === 'compact') root.removeAttribute('data-sidebar-width');
	else root.setAttribute('data-sidebar-width', width);
}

/** The width currently applied to documentElement (defaults to compact). */
export function readSidebarWidth(): SidebarWidth {
	if (typeof document === 'undefined') return 'compact';
	const v = document.documentElement.getAttribute('data-sidebar-width');
	return isSidebarWidth(v) ? v : 'compact';
}
